<!-- Simpler component API that gets the job done -->

<template>
  <Root :id="props.id">
    <Trigger>
      <TriggerButton
        :id="props.id"
        :variant="props.variant"
        :chevron="!props.icon"
      >
        <span class="flex items-center gap-2">
          <component
            :is="iconMappingMicro[icon]"
            v-if="icon"
            class="size-4 shrink-0"
          />

          <span class="truncate" :class="[icon && `hidden lg:inline`]">{{
            label
          }}</span>
        </span>
      </TriggerButton>
    </Trigger>

    <Container>
      <slot></slot>
    </Container>
  </Root>
</template>

<script setup lang="ts">
import { iconMappingMicro } from "@/icons/icon-mapping-micro";

import Container from "./Container.vue";
import Root from "./Root.vue";
import Trigger from "./Trigger.vue";
import TriggerButton from "./TriggerButton.vue";

const props = defineProps<{
  id?: string;
  label: string;
  variant?: "default";
  icon?: keyof typeof iconMappingMicro;
}>();
</script>
